import React from "react";
import { useRoutes } from "react-router-dom";
import ModuleWrap from "../components/ModuleWrap";

import AuthLayout from "../views/layouts/AuthLayout";
import MainLayout from "../views/layouts/MainLayout";

import Login from "../views/modules/Auth/Login";
import Register from "../views/modules/Auth/Register";
import PageNotFound from "../views/errors/PageNotFound";

import ResetPassword from "../views/modules/Auth/ResetPassword";
import ForgotPassword from "../views/modules/Auth/ForgotPassword";
// import HomePage from "../views/webPages/HomePage";
import Monitor from "../views/modules/Monitor";
// import Manual from '../views/modules/Manual';
import Users from "../views/modules/Users";
import Providers from "../views/modules/Providers";
import Reports from "../views/modules/Reports";
import PortingReports from "../views/modules/PortingReports";
import InternalReports from "../views/modules/InternalReports";
import ExternalReports from "../views/modules/ExternalReports";
import NumberManagement from "../views/modules/NumberManagement";
import AsteriskNumber from "../views/modules/AsteriskNumber";
import InternalNumberRouting from "../views/modules/InternalNumberRouting";
import ErrorCodes from "../views/modules/ErrorCodes";
import StarProviders from "../views/modules/StarProviders";
import UpdateAsteriskStatus from "../views/modules/UpdateAsteriskStatus";
import NetworkProviders from "../views/modules/NetworkProvider";
import NocProviders from "../views/modules/NocProvider";
import SupportProvider from "../views/modules/SupportProvider";
import UpdateSendEmailSupport from "../views/modules/UpdateSendEmailSupport";
import Support from "../views/modules/SendEmailSupport";
import WebHook from "../views/modules/WebHook";
import SIMManagement from "../views/modules/SIMManagement";
import CompanyManagement from "../views/modules/CompanyManagement";
import CompanyNumberManagement from "../views/modules/CompanyNumberManagement";
import Dashboard from "../views/modules/Dashboard";
import SoapReports from "../views/modules/Soap Reports";
import NumberManagementNumberAttributesReports from "../views/modules/Number Management Number Attributes Report";
import TotalNumberByAttributesReports from "../views/modules/TotalNumberByAttributesReports";
import AsteriskNumberByShadowPrefixReports from "../views/modules/AsteriskNumberByShadowPrefix";
import NumberManagementInternalPortedNumbersReports from "../views/modules/NumberManagementInternalPortedNumbers";
import PortedOutFromUsReports from "../views/modules/PortedOutFromUsReports";

export default function Router() {
  return useRoutes(RouterConfig);
}

export const RouterConfig = [
  {
    element: <AuthLayout />,
    children: [
      {
        path: "/",
        element: <Login />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/register",
        element: <Register />,
      },
      {
        path: "/forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "/reset-password/:userid/:otp",
        element: <ResetPassword />,
      },
    ],
  },
  {
    element: <MainLayout />,
    children: [
      {
        path: "/",
        element: <ModuleWrap module={Dashboard} permission={""} />,
      },
      {
        path: "/dashboard",
        element: <ModuleWrap module={Dashboard} permission={""} />,
      },
      {
        path: "/action",
        element: <ModuleWrap module={Monitor} permission={""} />,
      },
      // {
      //   path: '/manual',
      //   element: (
      //     <ModuleWrap
      //       module={Manual}
      //       permission={''}
      //     />
      //   ),
      // },
      {
        path: "/users",
        element: <ModuleWrap module={Users} permission={""} />,
      },
      {
        path: "/providers",
        element: <ModuleWrap module={Providers} permission={""} />,
      },
      {
        path: "/publish-report",
        element: <ModuleWrap module={Reports} permission={""} />,
      },
      {
        path: "/porting-report",
        element: <ModuleWrap module={PortingReports} permission={""} />,
      },
      {
        path: "/internal-report",
        element: <ModuleWrap module={InternalReports} permission={""} />,
      },
      {
        path: "/external-report",
        element: <ModuleWrap module={ExternalReports} permission={""} />,
      },
      {
        path: "/soap-report",
        element: <ModuleWrap module={SoapReports} permission={""} />,
      },
      {
        path: "/asterisk-number-by-shadow-prefix",
        element: (
          <ModuleWrap
            module={AsteriskNumberByShadowPrefixReports}
            permission={""}
          />
        ),
      },
      {
        path: "/internal-ported-numbers",
        element: (
          <ModuleWrap
            module={NumberManagementInternalPortedNumbersReports}
            permission={""}
          />
        ),
      },
      {
        path: "/ported-out-from-us-report",
        element: <ModuleWrap module={PortedOutFromUsReports} permission={""} />,
      },
      {
        path: "/number-attributes-report",
        element: (
          <ModuleWrap
            module={NumberManagementNumberAttributesReports}
            permission={""}
          />
        ),
      },
      {
        path: "/total-number-by-attribs-report",
        element: (
          <ModuleWrap module={TotalNumberByAttributesReports} permission={""} />
        ),
      },
      {
        path: "/asterisk-number",
        element: <ModuleWrap module={AsteriskNumber} permission={""} />,
      },
      {
        path: "/number-management",
        element: <ModuleWrap module={NumberManagement} permission={""} />,
      },
      {
        path: "/internal-number-routing",
        element: <ModuleWrap module={InternalNumberRouting} permission={""} />,
      },
      {
        path: "/error-codes",
        element: <ModuleWrap module={ErrorCodes} permission={""} />,
      },
      {
        path: "/star-providers",
        element: <ModuleWrap module={StarProviders} permission={""} />,
      },
      {
        path: "/network-providers",
        element: <ModuleWrap module={NetworkProviders} permission={""} />,
      },
      {
        path: "/noc-providers",
        element: <ModuleWrap module={NocProviders} permission={""} />,
      },
      {
        path: "/support-providers",
        element: <ModuleWrap module={SupportProvider} permission={""} />,
      },
      {
        path: "/support",
        element: <ModuleWrap module={Support} permission={""} />,
      },
      {
        path: "/webhooks",
        element: <ModuleWrap module={WebHook} permission={""} />,
      },
      {
        path: "/sim-management",
        element: <ModuleWrap module={SIMManagement} permission={""} />,
      },
      {
        path: "/company-management",
        element: <ModuleWrap module={CompanyManagement} permission={""} />,
      },
      {
        path: "/company-number-management",
        element: (
          <ModuleWrap module={CompanyNumberManagement} permission={""} />
        ),
      },

      {
        path: "*",
        element: <PageNotFound />,
      },
    ],
  },
  {
    path: "/update-asterisk-status/:asterisk_number/:provider_id/:provider_code/:network_identity",
    element: <UpdateAsteriskStatus />,
  },
  {
    path: "/update-emailSupport-status/:providerId/:id/:name/:network_identity",
    element: <UpdateSendEmailSupport />,
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
];
